<div
  class="kwikui-loader"
  *ngIf="loaderService.showLoader | async as isLoaderVisible"
  [class.fullscreen]="loaderService.fullscreen && true"
  [@panelInOut]="isLoaderVisible ? 'visible' : 'hidden'"
>
  <div class="loader-container">
    <span class="loader"></span>
    <div class="loader-text">{{ loaderService.loaderText }}</div>
  </div>
</div>
